const p1 = "https://winpeforum.com/assets/elements/azb_logo1_250x250.png";
const p2 = "https://winpeforum.com/assets/elements/A91Logo.png";
const p3 = "https://winpeforum.com/assets/elements/P1.png";
const p4 = "https://winpeforum.com/assets/elements/P4.png";
const p5 = "https://winpeforum.com/assets/elements/Gaza_Capital1_250x250.png";
const p6 =
  "https://winpeforum.com/assets/elements/General_Atlantic1_250x250.png";
const p7 = "https://winpeforum.com/assets/elements/IVCA_Logo.png";
const p8 = "https://winpeforum.com/assets/elements/kkr_logo1_250x250.png";
const p9 = "https://winpeforum.com/assets/elements/P6.png";
const p10 =
  "https://winpeforum.com/assets/elements/multiples_logo1_250x250.png";
const p11 = "https://winpeforum.com/assets/elements/MegaDelta_Logo.png";
const p12 = "https://winpeforum.com/assets/elements/Sequoia_edit_Logo.png";
const p13 = "https://winpeforum.com/assets/elements/sidbi_logo.png";
const p14 = "https://winpeforum.com/assets/elements/P7.png";
const p15 = "https://winpeforum.com/assets/elements/Truenorth_logo.png";
const p16 = "https://winpeforum.com/assets/elements/warburg_pincus_logo.png";
const p17 = "https://winpeforum.com/assets/elements/Apax_Logo.png";
const p18 = "https://winpeforum.com/assets/elements/postkalaari.png";
const p19 = "https://winpeforum.com/assets/elements/paragon.png";
const p20 = "https://winpeforum.com/assets/elements/UN_Women_logo.png";
const p21 = "https://winpeforum.com/assets/elements/RRA_Logo_Blue_RGB_PNG.png";
const p22 = "https://winpeforum.com/assets/elements/Arpwood_250x250.png";
const p23 = "https://winpeforum.com/assets/elements/CDC_logo.png";
const Newslette = [
  {
    desc1: `<div>Dear Friends, Partners, Colleagues,
			<br />
			<br />
				As I share the first quarterly newsletter on Winpe with you, I could not have visualized COVID-19 and how it has turned the world upside down creating uncertainties that stretch far into the future. I hope and pray all of you and your loved ones are well and stay that way.
			<br />
			<br />
      Winpe has gotten off to a fantastic start, Winpe launch was an afternoon of high quality candid conversation that has not been seen before. Each one of its members took the time from their intensely busy schedules, at short notice, to attend, participate and contribute. From Renuka’s personal note that touched everyone’s heart to Ameera’s honest reflections and Zia’s punchy close. A special shout out to Abhay, Mukund and Sandeep for putting themselves in the line of fire, being genuinely honest and hilariously funny!!
			<br />
			<br />
				The show of strength at the launch provided immense energy and motivation to me and the Winpe volunteers. We are off to a great start with our initiatives – more about that below. The coming quarter is looking productive as well. Stay tuned for emails on our executive skills session that is now converted s into an online format and the launch of the mentorship programme.
			<br />
			<br />
				This is the beginning and Winpe will continue to need your support:
		</div>`,
    desc2: `<div>Very importantly, please take 5 minutes to read our updates. Please talk to your teams, colleagues and friends about Winpe and, encourage them to take advantage of Winpe’s resources
			<br />
			<br />
				Gender diversity and balance can only be achieved if we all work together and we are off to a strong start. I would like to thank all of our members for rallying together in this commitment to enhancing diversity and look forward to working together in realising it.
			<br />
			<br />
				Take care and stay safe
			<br />
			<br />
				Nupur
		</div>`,
  },
];

const Plogo = [
  {
    id: 1,
    pLogo: p1,
  },
  {
    id: 2,
    pLogo: p2,
  },
  {
    id: 3,
    pLogo: p3,
  },
  {
    id: 4,
    pLogo: p4,
  },
  {
    id: 5,
    pLogo: p5,
  },
  {
    id: 6,
    pLogo: p6,
  },
  {
    id: 7,
    pLogo: p7,
  },
  {
    id: 8,
    pLogo: p8,
  },
  {
    id: 9,
    pLogo: p9,
  },
  {
    id: 10,
    pLogo: p10,
  },
  {
    id: 11,
    pLogo: p11,
  },
  {
    id: 12,
    pLogo: p12,
  },
  {
    id: 13,
    pLogo: p13,
  },
  {
    id: 14,
    pLogo: p14,
  },
  {
    id: 15,
    pLogo: p15,
  },
  {
    id: 16,
    pLogo: p16,
  },
];
const Plogonew = [
  {
    id: 17,
    pLogo: p17,
  },
  {
    id: 1,
    pLogo: p1,
  },
  {
    id: 2,
    pLogo: p2,
  },
  {
    id: 3,
    pLogo: p3,
  },
  {
    id: 4,
    pLogo: p4,
  },
  {
    id: 5,
    pLogo: p5,
  },
  {
    id: 6,
    pLogo: p6,
  },
  {
    id: 7,
    pLogo: p7,
  },
  {
    id: 18,
    pLogo: p18,
  },
  {
    id: 8,
    pLogo: p8,
  },
  {
    id: 9,
    pLogo: p9,
  },
  {
    id: 11,
    pLogo: p11,
  },
  {
    id: 10,
    pLogo: p10,
  },
  {
    id: 19,
    pLogo: p19,
  },
  {
    id: 12,
    pLogo: p12,
  },
  {
    id: 13,
    pLogo: p13,
  },
  {
    id: 14,
    pLogo: p14,
  },
  {
    id: 15,
    pLogo: p15,
  },
  {
    id: 16,
    pLogo: p16,
  },
];
const PlogoSep = [
  {
    id: 17,
    pLogo: p17,
  },
  {
    id: 17,
    pLogo: p22,
  },
  {
    id: 1,
    pLogo: p1,
  },
  {
    id: 2,
    pLogo: p2,
  },
  {
    id: 3,
    pLogo: p3,
  },
  {
    id: 4,
    pLogo: p4,
  },
  {
    id: 5,
    pLogo: p5,
  },
  {
    id: 6,
    pLogo: p6,
  },
  // {
  // 	id:7,
  // 	pLogo:p7
  // },
  {
    id: 18,
    pLogo: p18,
  },
  {
    id: 8,
    pLogo: p8,
  },
  {
    id: 9,
    pLogo: p9,
  },
  {
    id: 11,
    pLogo: p11,
  },
  {
    id: 10,
    pLogo: p10,
  },
  {
    id: 19,
    pLogo: p19,
  },
  // {
  // 	id:19,
  // 	pLogo:p21
  // },
  {
    id: 12,
    pLogo: p12,
  },
  {
    id: 13,
    pLogo: p13,
  },
  {
    id: 14,
    pLogo: p14,
  },
  {
    id: 15,
    pLogo: p15,
  },
  {
    id: 15,
    pLogo: p20,
  },
  {
    id: 16,
    pLogo: p16,
  },
];

const PlogoOct = [
  {
    id: 17,
    pLogo: p17,
  },
  {
    id: 17,
    pLogo: p22,
  },
  {
    id: 1,
    pLogo: p1,
  },
  {
    id: 2,
    pLogo: p2,
  },
  {
    id: 2,
    pLogo: p23,
  },
  {
    id: 3,
    pLogo: p3,
  },
  {
    id: 4,
    pLogo: p4,
  },
  {
    id: 5,
    pLogo: p5,
  },
  {
    id: 6,
    pLogo: p6,
  },
  // {
  // 	id:7,
  // 	pLogo:p7
  // },
  {
    id: 18,
    pLogo: p18,
  },
  {
    id: 8,
    pLogo: p8,
  },
  {
    id: 9,
    pLogo: p9,
  },
  {
    id: 11,
    pLogo: p11,
  },
  {
    id: 10,
    pLogo: p10,
  },
  {
    id: 19,
    pLogo: p19,
  },
  // {
  // 	id:19,
  // 	pLogo:p21
  // },
  {
    id: 12,
    pLogo: p12,
  },
  {
    id: 13,
    pLogo: p13,
  },
  {
    id: 14,
    pLogo: p14,
  },
  {
    id: 15,
    pLogo: p15,
  },
  {
    id: 15,
    pLogo: p20,
  },
  {
    id: 16,
    pLogo: p16,
  },
];

export { Newslette, Plogo, Plogonew, PlogoSep, PlogoOct };



// WEBPACK FOOTER //
// ./src/constant/newslette.js